import React, { useLayoutEffect, useState } from 'react'
import useStyles from './style'
import { useTheme } from '@emotion/react'
import { Box, Grid, Typography } from '@mui/material'
import noInternetImg from "../../assets/images/noInternet.png"
const NoNetwork = ({children}) => {
    const classes = useStyles()
    const [isOnline , setOnline] = useState(true)
    useLayoutEffect(() => {
        setOnline(navigator.onLine)
    },[])
    window.addEventListener("online" , () => {
        setOnline(true)
    })
    window.addEventListener( "offline" , () => {
        setOnline(false)
    })
    if(isOnline){
        return children
    }
  return (
    <Box className={classes.errorImageBox}>
    <img className={classes.noInternetImage} src={noInternetImg} alt='error-404-image'  loading='lazy'/>
    <Grid className={classes.errorTextGrid} container direction="column" alignItems="center">
        <Grid item>
            <Typography className={classes.errorHeading} variant="h5">
                NO INTERNET C<span style={{color:'#dc1a5c'}}>O</span>NNECTION FOUND!</Typography>
        </Grid>
        <Grid item>
            <Typography className={classes.errorBody} variant="body1">
                It seems there is something wrong with your internet connection. Please connect to the internet and try again.
            </Typography>
        </Grid>
    </Grid>
</Box>
  )
}

export default NoNetwork